import { render, staticRenderFns } from "./sumur_artesis.vue?vue&type=template&id=6fba80f1&"
import script from "./sumur_artesis.vue?vue&type=script&lang=js&"
export * from "./sumur_artesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports